import { render, staticRenderFns } from "./PrijavniObrazecIP.vue?vue&type=template&id=2e8c4b0b&"
import script from "./PrijavniObrazecIP.vue?vue&type=script&lang=js&"
export * from "./PrijavniObrazecIP.vue?vue&type=script&lang=js&"
import style0 from "./PrijavniObrazecIP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports